import { DialogProps } from '@optools/components/ui/dialog';
import { Sheet, SheetContent } from '@optools/components/ui/sheet';
import { cn } from '@optools/components/ui/utils';
import {
  MediaPolicy,
  ViewingPolicy,
} from '@optools/services/operator-gateway/types/generated/graphql';
import { useMemo } from 'react';

import { AudienceDetail } from './audience-detail';
import { EsniBreadcrumbs } from './esni-breadcrumbs';
import { MediaDetail } from './media-detail';
import { PolicyDetail } from './policy-detail';

export interface EsniDetailsSheetProps extends DialogProps {
  audienceHref?: string[];
  mediaPolicy?: MediaPolicy;
  viewingPolicy?: ViewingPolicy;
}

export function EsniDetailsSheet({
  audienceHref,
  mediaPolicy,
  onOpenChange,
  open,
  viewingPolicy,
}: EsniDetailsSheetProps) {
  const content = useMemo(() => {
    if (audienceHref?.length) {
      return (
        <AudienceDetail
          key={audienceHref[audienceHref.length - 1]}
          audienceHref={audienceHref[audienceHref.length - 1]}
          onOpenChange={onOpenChange}
        />
      );
    }
    if (viewingPolicy)
      return <PolicyDetail viewingPolicy={viewingPolicy} onOpenChange={onOpenChange} />;
    if (mediaPolicy) return <MediaDetail mediaPolicy={mediaPolicy} />;
    return null;
  }, [audienceHref, mediaPolicy, viewingPolicy, onOpenChange]);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        className={cn({
          'lg:max-w-(--breakpoint-sm)': viewingPolicy || audienceHref?.length,
          'lg:max-w-(--breakpoint-xl)': mediaPolicy && !viewingPolicy && !audienceHref?.length,
        })}>
        <EsniBreadcrumbs />
        {content}
      </SheetContent>
    </Sheet>
  );
}
